/**
 * @deprecated Use CheckoutRoute instead
 */
export enum CartRoute {
  Cart = '/checkout/cart',
  Options = 'options',
  TransferOption = 'transfer',
  Share = 'share',
  ShareGenerated = 'generated',
  EditItem = 'edit-item',
  SalesAssociateCode = 'code',
}
